import React from 'react';

const VenueDetails = () => {
  const scrollToBooking = () => {
    document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
  <section
    id="facilities"
    className="relative w-full overflow-hidden"
    style={{ aspectRatio: '1024 / 280' }}
    aria-label="Our Venue — A Unique Driving Environment"
  >
    <img
      src="/design-master/KYLE-DRIVE-APPROVED-DESIGN.png"
      alt="The Kyle Rise — A Unique Driving Environment"
      className="absolute left-0 w-full max-w-none"
      style={{
        top: '-280.36%',
        height: 'auto'
      }}
    />

    <div
      aria-hidden="true"
      className="absolute top-0 left-0 right-0 h-8 pointer-events-none"
      style={{
        background:
          'linear-gradient(to bottom, rgba(236,248,255,0.95), rgba(236,248,255,0))'
      }}
    />

    <button
      type="button"
      onClick={scrollToBooking}
      aria-label="Learn More about booking"
      className="absolute bg-transparent border-0 cursor-pointer z-10"
      style={{
        left: '2.5%',
        top: '43%',
        width: '26%',
        height: '18%'
      }}
    />
  </section>
  );
};

export default VenueDetails;
